import React from 'react';
import { Row, Col, Button, Modal, Form, InputGroup } from 'react-bootstrap';
import { useEditDeviceModal } from './useEditDeviceModal';

const EditDeviceModal = () => {

  const { isActive, handleClose, handleEditButtonClick, newDisplayName, setNewDisplayName, deviceId } = useEditDeviceModal();

  return (
    <>

      <Modal show={isActive} onHide={handleClose} className='modal-container' centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Device Name</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleEditButtonClick}>
          <Modal.Body>
            <div className='add-group-container'>
              <label>Device Id</label>
              <span style={{ marginLeft: "2rem" }}>
                {deviceId}
              </span>
            </div>
            <div className='add-group-container'>
              <label>Device Name</label>
              <Row>
                <Col sm={6}>
                  <div className='add-group-input'>
                    <Form.Control
                      placeholder="Type in the device name..."
                      type="text"
                      aria-describedby="basic-addon2"
                      value={newDisplayName}
                      onChange={(e) => setNewDisplayName(e.target.value)}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn-cancel' onClick={handleClose}>
              Cancel
            </Button>
            <Button className='btn-style' onClick={handleEditButtonClick}>
              Edit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default EditDeviceModal;